<template>
  <el-drawer title="Mensagens dos clientes" class="chat" :visible.sync="drawer" direction="rtl" size="420px">
    <el-table :data="customerData" :row-style="tableRowStyle" style="width: 100%" :show-header="false" v-if="home">
      <el-table-column width="50px">
        <template slot-scope="scope">
          <span class="badge badge-primary badge-pill">{{ scope.row.message.length }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="username">
        <template slot-scope="scope">
          {{ scope.row.username.length > 25 ? scope.row.username.substring(0, 25)
            + '...' : scope.row.username
          }}
        </template>
      </el-table-column>
      <el-table-column width="120px">
        <template slot-scope="scope">
          <el-link style="font-size: 12px;" icon="el-icon-service"
            @click="response(scope.row.department, scope.row.userId)">Responder</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="chat-body" v-else>
      <chat-list :msgs="msgData" :userId="userId"></chat-list>
      <chat-form state="operator" :disabled="connected === false" @chat="sendMessage" @close="close"
        @home="socket.emit('chat-get-not-read', userId); home = true" @transfer="transfer"></chat-form>
    </div>
  </el-drawer>
</template>

<script>
import ChatList from "./components/ChatList";
import ChatForm from "./components/ChatForm";
import DepartmentChat from '@/xpost/views/register/department/DepartmentChat'
import { DateTime, Settings } from 'luxon';
Settings.defaultLocale = 'pt-br';
Settings.defaultZone = 'America/Sao_Paulo';

export default {
  props: ["socket", "username", "userId"],
  data() {
    return {
      drawer: false,
      connected: false,
      home: true,
      department: '',
      msgData: [],
      customerData: [],
    };
  },
  components: {
    ChatList,
    ChatForm,
    DepartmentChat,
  },
  methods: {
    tableRowStyle({ row, rowIndex }) {
      return { 'background-color': row.color };
    },
    open() {
      this.drawer = true;
    },
    clear() {
      this.msgData = [];
    },
    close() {
      this.connected = false;
      this.socket.emit('chat-close', this.userId);
    },
    transfer(department) {
      this.socket.emit('chat-transfer', { department, userId: this.userId });
    },
    response(department, userId) {
      this.connected = true;
      this.home = false;
      this.socket.emit('chat-operator-response', { userId, department, username: this.username });
    },
    received(type, data, connected) {
      if (type === 'operator') {
        return this.customerData = data
      }
      else {
        this.departament = data.departament;
        this.msgData.push(data);
        this.connected = connected;
      }
      setTimeout(() => {
        const element = document.getElementById("chat__body");
        element.scrollTop = element.scrollHeight;
      }, 0);
    },
    sendMessage(msg) {
      const now = DateTime.now().setZone('America/Sao_Paulo').setLocale('pt-br').toFormat('HH:mm')
      const data = {
        message: msg,
        userId: this.userId,
        username: this.username,
        time: now,
      }
      this.msgData.push(data);

      this.socket.emit('chat-message', data)
      setTimeout(() => {
        const element = document.getElementById("chat__body");
        element.scrollTop = element.scrollHeight;
      }, 0);
    },
  },
};
</script>

<style scoped>
.el-drawer__header {
  margin-bottom: 2px !important;
}

.customer-list {
  width: 390px;
  margin-left: 8px;
}

.el-alert__description {
  width: 100%;
}

.chat {
  margin: 20px;
  border-radius: 15px;
}


.chat-body {
  margin: 10px;
  height: 95%;
  flex-direction: column;
  display: flex;
  justify-content: space-between;

}

.chat__header {
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05);
  border-radius: 24px 24px 0px 0px;
  padding: 1.8rem;
  font-size: 16px;
  font-weight: 700;
}

.chat.el-drawer__open.el-drawer {
  border-radius: 15px !important;
  background-color: aqua !important;
}

.chat__header__greetings {
  color: #292929;
}
</style>